<template>
  <v-bottom-sheet v-model="sheet_bottom_combo">
    <v-sheet class="sheet-listCombo">
      <v-container class="pt-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
            <v-radio-group v-model="selectedCommodityModel" hide-details class="mt-0 combo-items-tag">
              <v-radio v-for="(detail, i) in commodity" :key="i" :value="detail" color="olbrand" :disabled="detail.disabled" :ripple="false" class="combo-items-tag-detail">
                <template v-slot:label>
                  <div class="item-combo-with-image">
                    <div :class="['item-combo-with-image-avatar', { 'item-combo-image-disable': detail.disabled }]">
                      <img :src="detail.image" :alt="detail.name" @error="imageLoadError">
                    </div>
                    <div class="item-combo-with-image-content">
                      <div class="item-combo-with-image-title font-weight-600 font-14">
                        {{ detail.name }}
                      </div>
                    </div>
                  </div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
export default {
  name: 'ListCombo',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: null
    },
    commodity: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    sheet_bottom_combo: {
      get() {
        return this.open
      },
      set(val) {
        this.$emit('update:open', val)
      }
    },
    selectedCommodityModel: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
        this.$emit('update:open', false)
      }
    }
  },
  methods: {
    imageLoadError(event) {
      event.target.src = require('@/assets/images/product_not_available.png')
    }
  }
}
</script>

<style>
.sheet-listCombo {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 100%;
  min-height: 400px;
  max-height: 800px;
  padding: 16px;
}
</style>
